import { createAction } from '@reduxjs/toolkit'
import {
  CodeValidationAgent,
  CodeValidationStatus,
  CodeValidationDiscipline,
  Task,
  CodeValidationRule,
  CodeValidationRuleStatus,
} from '../models/Validation'

export const addCodeValidationRulesForDiscipline = createAction<{
  discipline: CodeValidationDiscipline
  rules: CodeValidationRule[]
}>('validation/addCodeValidationRulesForDiscipline')
export const updateCodeValidationRulesWithStatus = createAction<{
  data: CodeValidationRuleStatus[]
}>('validation/updateCodeValidationRulesWithStatus')

export const selectCodeValidationRule = createAction<{
  item: CodeValidationRule
}>('validation/selectCodeValidationRule')
export const selectCodeValidationItem = createAction<{
  item: string
}>('validation/selectCodeValidationItem')
export const selectCodeValidationRuleElement = createAction<{
  item: CodeValidationRuleStatus | null
}>('validation/selectCodeValidationRuleElement')
export const deselectCodeValidationRule = createAction(
  'validation/deselectCodeValidationRule',
)

export const selectCodeValidationDiscipline = createAction<{
  value: CodeValidationDiscipline
}>('validation/selectCodeValidationDiscipline')
export const deselectCodeValidationDiscipline = createAction<{
  value: CodeValidationDiscipline
}>('validation/deselectCodeValidationDiscipline')

export const selectCodeValidationStatus = createAction<{
  value: CodeValidationStatus
}>('validation/selectCodeValidationStatus')
export const deselectCodeValidationStatus = createAction<{
  value: CodeValidationStatus
}>('validation/deselectCodeValidationStatus')

export const selectFilterByCodeValidationStatusesForDiscipline = createAction<{
  discipline: CodeValidationDiscipline
  status: CodeValidationStatus
}>('validation/selectFilterByCodeValidationStatusesForDiscipline')
export const deselectFilterByCodeValidationStatusesForDiscipline =
  createAction<{
    discipline: CodeValidationDiscipline
    status: CodeValidationStatus
  }>('validation/deselectFilterByCodeValidationStatusesForDiscipline')

export const setCodeValidationAgent = createAction<{
  agent: CodeValidationAgent
}>('validation/setCodeValidationAgent')

export const setShowCodeValidationOptionsModal = createAction<boolean>(
  'validation/setShowCodeValidationOptionsModal',
)

export const setIsCodeValidationStatusChecking = createAction<boolean>(
  'validation/setIsCodeValidationStatusChecking',
)
export const setIsCodeValidationProcessingStarted = createAction<boolean>(
  'validation/setIsCodeValidationProcessingStarted',
)

export const setCurrentValidationTask = createAction<Task | null>(
  'validation/setCurrentValidationTask',
)
export const setCurrentValildationMessages = createAction<string[]>(
  'validation/setCurrentValildationMessages',
)
export const resetCodeValidationState = createAction(
  'validation/resetCodeValidationState',
)
export const setIsAllCodeValidationRulesFetched = createAction<boolean>(
  'validation/setIsAllCodeValidationRulesFetched',
)
